<div class="modal-header">
	<h2 class="mt-2" >
		<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
			<g fill="none" fill-rule="evenodd">
				<g fill="#0CC5D1">
					<path
						d="M32.786 0C33.456 0 34 .544 34 1.214v13.358c0 .322-.128.63-.356.858L15.43 33.644c-.474.475-1.243.475-1.717 0L.356 20.287c-.475-.474-.475-1.243 0-1.717L18.57.356c.228-.228.536-.356.858-.356zM31.57 2.429h-11.64l-17 17 11.64 11.64 17-17V2.429zM25.5 4.857c2.012 0 3.643 1.631 3.643 3.643 0 2.012-1.631 3.643-3.643 3.643-2.012 0-3.643-1.631-3.643-3.643 0-2.012 1.631-3.643 3.643-3.643zm0 2.429c-.67 0-1.214.543-1.214 1.214 0 .67.543 1.214 1.214 1.214.67 0 1.214-.543 1.214-1.214 0-.67-.543-1.214-1.214-1.214z"
						transform="translate(-704 -231) translate(440 199) translate(214 20) translate(0 12) translate(50)" />
				</g>
			</g>
		</svg>
		<ng-container i18n="@@add_city.add_new_city">Add City</ng-container>
	</h2>

	<p>
		<ng-container i18n="@@add_city.city_noticed">Hello {{ userInfo?.full_name }}!<br> We noticed you haven’t added your city yet,
			kindly add it up now so we can serve you better.</ng-container>
	</p>
</div>
<div class="modal-body">
	<form class="add-city" [formGroup]="addCityForm" (ngSubmit)="onSubmit()" #cityForm="ngForm">

		<fieldset
			[ngClass]="{'has-error': submitted && addCityForm.get('region_id').errors && addCityForm.get('region_id').errors.required}">
			<label for="region" i18n="@@add_city.region">Region</label>
			<select app-select2 [options]="{
					ajax: {url: regionListApi},
					idColumn: 'id',
					textColumn: 'name'
				}" (itemSelected)="onChangeRegion($event)"
				i18n-data-placeholder="@@add_city.select_region" data-placeholder="Select Region" formControlName="region_id">
				<option></option>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset
			[ngClass]="{'has-error': submitted && addCityForm.get('city_id').errors && addCityForm.get('city_id').errors.required}">
			<label for="city" i18n="@@add_city.city">City</label>
			<select app-select2 [options]="{
			  data: cities ? cities : [],
			  idColumn: 'id',
			  textColumn: 'name'
			}" [params]="{cityId:f.region_id.value}" (itemSelected)="onChangeCity($event)"
				i18n-data-placeholder="@@add_city.select_city" data-placeholder="Select City" formControlName="city_id">
				<option></option>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset
			[ngClass]="{'has-error': submitted && addCityForm.get('district_id').errors && addCityForm.get('district_id').errors.required}">
			<label for="district" i18n="@@add_city.district">District</label>
			<select app-select2 [options]="{
			  data: districts ? districts : [],
			  idColumn: 'id',
			  textColumn: 'name'
			}"
				i18n-data-placeholder="@@add_city.select_district" data-placeholder="Select District"
				formControlName="district_id">
				<option></option>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>
	</form>
</div>
<div class="modal-footer">
	<button type="button" class="tu-btn blue" form="ngForm" (click)="cityForm.ngSubmit.emit()" i18n="@@add_city.add_new_city">
		Add City
	</button>
</div>
